import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, FormGroup, ValidationErrors } from '@angular/forms';
import { isNullOrUndefined } from 'util';

@Directive({
  selector: '[appCheckUserName]',
  providers: [{ provide: NG_VALIDATORS, useExisting: CheckUserNameDirective, multi: true }]
})
export class CheckUserNameDirective {

  @Input() appCheckUserName = [];
  @Input() appCheckUserNamePrefix = [];
  
  validate(formGroup: FormGroup): ValidationErrors {
    return this.checkForUnicode(this.appCheckUserName)(formGroup);
  }

  private checkForUnicode(controlName: string[]) {
    return (formGroup: FormGroup) => {
      const controlCheck = formGroup.controls[controlName[0]];
      const controlCheck2 = formGroup.controls[controlName[2]];
      const controlCheck3 = formGroup.controls[controlName[3]];
      const controlCheck4 = formGroup.controls[controlName[4]];
      const controlCheck5 = formGroup.controls[controlName[5]];
      const controlCheck6 = formGroup.controls[controlName[6]];

      if (controlCheck != null && controlCheck.value != null && controlCheck.value !== '') {
        let initalValue = controlCheck.value;

        // right know only one place use this directive and has only the first control has username-prefix
        // so this code only check for the first one
        if (initalValue) {
          if ( this.appCheckUserNamePrefix.length > 0 ){
            const firstUsernamePrefix = this.appCheckUserNamePrefix[0].trim();
            if (initalValue.trim() === firstUsernamePrefix) {
              controlCheck.setErrors({ invalidRequired: true });
              // if the username is empty return error immediately, don't check more
              return null;
            }
          }
        }

        initalValue = initalValue.replace(/[^0-9a-zA-Z_/-]*/g, '');

        if (initalValue !== controlCheck.value || initalValue.length < 5) {
          controlCheck.setErrors({ validIp: true });
        } else {
          controlCheck.setErrors(null);
        }
      }

      // Return null if controls haven't initialised yet
      if (controlCheck2 != null && controlCheck2.value != null && controlCheck2.value !== '') {

        let initalValue = controlCheck2.value;
        initalValue = initalValue.replace(/[^0-9a-zA-Z-]*/g, '');
        if (initalValue !== controlCheck2.value) {
          controlCheck2.setErrors({ validIp: true });
        } else {
          controlCheck2.setErrors(null);
        }
      }

      if (controlCheck3 != null && controlCheck3.value != null && controlCheck3.value !== '') {
        let initalValue = controlCheck3.value;
        initalValue = initalValue.replace(/[^0-9a-zA-Z-]*/g, '');
        if (initalValue !== controlCheck3.value) {
          controlCheck3.setErrors({ validIp: true });
        } else {
          controlCheck3.setErrors(null);
        }
      }

      // Return null if controls haven't initialised yet
      if (controlCheck4 != null && controlCheck4.value != null && controlCheck4.value !== '') {
        let initalValue = controlCheck4.value;
        initalValue = initalValue.replace(/[^0-9a-zA-Z-]*/g, '');
        if (initalValue !== controlCheck4.value) {
          controlCheck4.setErrors({ validIp: true });
        } else {
          controlCheck4.setErrors(null);
        }
      }

      // Return null if controls haven't initialised yet
      if (controlCheck5 != null && controlCheck5.value != null && controlCheck5.value !== '') {
        let initalValue = controlCheck5.value;
        initalValue = initalValue.replace(/[^0-9a-zA-Z-]*/g, '');
        if (initalValue !== controlCheck5.value) {
          controlCheck5.setErrors({ validIp: true });
        } else {
          controlCheck5.setErrors(null);
        }
      }

      // Return null if controls haven't initialised yet
      if (controlCheck6 != null && controlCheck6.value != null && controlCheck6.value !== '') {
        let initalValue = controlCheck6.value;
        initalValue = initalValue.replace(/[^0-9a-zA-Z-]*/g, '');
        if (initalValue !== controlCheck6.value) {
          controlCheck6.setErrors({ validIp: true });
        } else {
          controlCheck6.setErrors(null);
        }
      }

      if (!controlCheck4 || isNullOrUndefined(controlCheck4.value) || controlCheck4.value === '') {
        return null;
      }
    };
  }
}
